import { render } from "./DrawingBoard.vue?vue&type=template&id=65df3ed2&scoped=true"
import script from "./DrawingBoard.vue?vue&type=script&lang=js"
export * from "./DrawingBoard.vue?vue&type=script&lang=js"

import "./DrawingBoard.vue?vue&type=style&index=0&id=65df3ed2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65df3ed2"]])

export default __exports__